import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useParams } from 'react-router-dom'
import Scroll from 'react-scroll';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTable, faArrowRight, faTasks, faTachometer, faEye, faPlus, faTrashCan, faVideo, faPencil, faArrowLeft, faTrash } from '@fortawesome/free-solid-svg-icons'
import Select from 'react-select'

import { EQUIPMENT_OPTIONS } from "../../Constants/FieldOptions";
import { getSessionTemplateDetailAPI } from "../../API/SessionTemplate";
import { getSelectedOptions } from "../../Helpers/selectHelper";
import { putSessionTemplateUpdateAPI } from "../../API/SessionTemplate";
import FormErrorBox from "../Reusable/FormErrorBox";
import FormInputField from "../Reusable/FormInputField";
import FormTextareaField from "../Reusable/FormTextareaField";
import FormMultiSelectField from "../Reusable/FormMultiSelectField";
import FormRadioField from "../Reusable/FormRadioField";
import PageLoadingContent from "../Reusable/PageLoadingContent";
import { getSessionTemplateListAPI, deleteSessionTemplateAPI } from "../../API/SessionTemplate";
import { useRecoilState } from 'recoil';
import { topAlertMessageState, topAlertStatusState } from "../../AppState";


function SessionTemplateDetailForVideoSection() {
    ////
    //// Global state.
    ////

    const [topAlertMessage, setTopAlertMessage] = useRecoilState(topAlertMessageState);
    const [topAlertStatus, setTopAlertStatus] = useRecoilState(topAlertStatusState);

    ////
    //// URL Parameters.
    ////

    const { id } = useParams()

    ////
    //// Component states.
    ////

    const [errors, setErrors] = useState({});
    const [sessionTemplate, setSessionTemplate] = useState({});
    const [selectedVideoSectionForDeletion, setSelectedVideoSectionForDeletion] = useState("");
    const [isFetching, setFetching] = useState(false);

    ////
    //// API.
    ////

    function onSessionTemplateDetailForVideoSectionSuccess(response){
        console.log("onSessionTemplateDetailForVideoSectionSuccess: Starting...");
        setSessionTemplate(response);
    }

    function onSessionTemplateDetailForVideoSectionError(apiErr) {
        console.log("onSessionTemplateDetailForVideoSectionError: Starting...");
        setErrors(apiErr);

        // The following code will cause the screen to scroll to the top of
        // the page. Please see ``react-scroll`` for more information:
        // https://github.com/fisshy/react-scroll
        var scroll = Scroll.animateScroll;
        scroll.scrollToTop();
    }

    function onSessionTemplateDetailForVideoSectionDone() {
        console.log("onSessionTemplateDetailForVideoSectionDone: Starting...");
        setFetching(false);
    }

    function onVideoSectionDeleteSuccess(response){
        console.log("onVideoSectionDeleteSuccess: Starting..."); // For debugging purposes only.

        // Update notification.
        setTopAlertStatus("success");
        setTopAlertMessage("Video section deleted");
        setTimeout(() => {
            console.log("onDeleteConfirmButtonClick: topAlertMessage, topAlertStatus:", topAlertMessage, topAlertStatus);
            setTopAlertMessage("");
        }, 2000);

        // Fetch again an updated list.
        // fetchList();
    }

    function onVideoSectionDeleteError(apiErr) {
        console.log("onVideoSectionDeleteError: Starting..."); // For debugging purposes only.
        setErrors(apiErr);

        // Update notification.
        setTopAlertStatus("danger");
        setTopAlertMessage("Failed deleting");
        setTimeout(() => {
            console.log("onVideoSectionDeleteError: topAlertMessage, topAlertStatus:", topAlertMessage, topAlertStatus);
            setTopAlertMessage("");
        }, 2000);

        // The following code will cause the screen to scroll to the top of
        // the page. Please see ``react-scroll`` for more information:
        // https://github.com/fisshy/react-scroll
        var scroll = Scroll.animateScroll;
        scroll.scrollToTop();
    }

    function onVideoSectionDeleteDone() {
        console.log("onVideoSectionDeleteDone: Starting...");
        setFetching(false);
    }

    ////
    //// Event handling.
    ////

    const onSelectVideoSectionForDeletion = (e, videoSection) => {
        console.log("onSelectVideoSectionForDeletion", videoSection);
        setSelectedVideoSectionForDeletion(videoSection);
    }

    const onDeselectVideoSectionForDeletion = (e) => {
        console.log("onDeselectVideoSectionForDeletion");
        setSelectedVideoSectionForDeletion("");
    }

    const onDeleteConfirmButtonClick = (e) => {
        console.log("onDeleteConfirmButtonClick", selectedVideoSectionForDeletion); // For debugging purposes only.

        //
        // The following code will remove the data from the JSON.
        //

        let vsIndex;
        for (let videoSectionIndex in sessionTemplate.videoSections) {
            let vs = sessionTemplate.videoSections[videoSectionIndex];
            if (vs.name === selectedVideoSectionForDeletion.name) {
                vsIndex = videoSectionIndex;
                break;
            }
        }
        console.log("videoSectionIndex:", vsIndex);
        sessionTemplate.videoSections.splice(vsIndex, 1);

        // Remove from state.
        setSelectedVideoSectionForDeletion("");

        // Update the sessionTemplate.
        console.log("onSubmitClick, sessionTemplate:", sessionTemplate);
        putSessionTemplateUpdateAPI(sessionTemplate, onSessionTemplateUpdateSuccess, onSessionTemplateUpdateError, onSessionTemplateUpdateDone);
    }

    function onSessionTemplateUpdateSuccess(response){
        // For debugging purposes only.
        console.log("onSessionTemplateUpdateSuccess: Starting...");
        console.log(response);

        // Add a temporary banner message in the app and then clear itself after 2 seconds.
        setTopAlertMessage("SessionTemplate updated");
        setTopAlertStatus("success");
        setTimeout(() => {
            console.log("onSessionTemplateUpdateSuccess: Delayed for 2 seconds.");
            console.log("onSessionTemplateUpdateSuccess: topAlertMessage, topAlertStatus:", topAlertMessage, topAlertStatus);
            setTopAlertMessage("");
        }, 2000);
    }

    function onSessionTemplateUpdateError(apiErr) {
        console.log("onSessionTemplateUpdateError: Starting...");
        setErrors(apiErr);

        // Add a temporary banner message in the app and then clear itself after 2 seconds.
        setTopAlertMessage("Failed submitting");
        setTopAlertStatus("danger");
        setTimeout(() => {
            console.log("onSessionTemplateUpdateError: Delayed for 2 seconds.");
            console.log("onSessionTemplateUpdateError: topAlertMessage, topAlertStatus:", topAlertMessage, topAlertStatus);
            setTopAlertMessage("");
        }, 2000);

        // The following code will cause the screen to scroll to the top of
        // the page. Please see ``react-scroll`` for more information:
        // https://github.com/fisshy/react-scroll
        var scroll = Scroll.animateScroll;
        scroll.scrollToTop();
    }

    function onSessionTemplateUpdateDone() {
        console.log("onSessionTemplateUpdateDone: Starting...");
        setFetching(false);
    }

    ////
    //// Misc.
    ////

    useEffect(() => {
        let mounted = true;

        if (mounted) {
            window.scrollTo(0, 0);  // Start the page at the top of the page.

            setFetching(true);
            getSessionTemplateDetailAPI(
                id,
                onSessionTemplateDetailForVideoSectionSuccess,
                onSessionTemplateDetailForVideoSectionError,
                onSessionTemplateDetailForVideoSectionDone
            );
        }

        return () => { mounted = false; }
    }, [id]);

    ////
    //// Component rendering.
    ////

    return (
        <>
            <div class="container">
                <section class="section">
                    {/* Desktop Breadcrumbs */}
                    <nav class="breadcrumb is-hidden-touch" aria-label="breadcrumbs">
                        <ul>
                            <li><Link to="/dashboard"><FontAwesomeIcon className="fas" icon={faTachometer} />&nbsp;Dashboard</Link></li>
                            <li class=""><Link to="/session-templates" aria-current="page"><FontAwesomeIcon className="fas" icon={faTasks} />&nbsp;Session Templates</Link></li>
                            <li class="is-active"><Link to={`/session-template`} aria-current="page"><FontAwesomeIcon className="fas" icon={faEye} />&nbsp;Details (Video Sections)</Link></li>
                        </ul>
                    </nav>

                    {/* Mobile Breadcrumbs */}
                    <nav class="breadcrumb is-hidden-desktop" aria-label="breadcrumbs">
                        <ul>
                            <li class=""><Link to={`/session-templates`} aria-current="page"><FontAwesomeIcon className="fas" icon={faArrowLeft} />&nbsp;Back to Session Templates</Link></li>
                        </ul>
                    </nav>

                    {/* Modal(s) */}
                    <nav class="">
                        <div class={`modal ${selectedVideoSectionForDeletion ? 'is-active' : ''}`}>
                            <div class="modal-background"></div>
                            <div class="modal-card">
                                <header class="modal-card-head">
                                    <p class="modal-card-title">Are you sure?</p>
                                    <button class="delete" aria-label="close" onClick={onDeselectVideoSectionForDeletion}></button>
                                </header>
                                <section class="modal-card-body">
                                    You are about to delete this video section and all the data inside of it. This action is cannot be undone. Are you sure you would like to continue?
                                </section>
                                <footer class="modal-card-foot">
                                    <button class="button is-success" onClick={onDeleteConfirmButtonClick}>Confirm</button>
                                    <button class="button" onClick={onDeselectVideoSectionForDeletion}>Cancel</button>
                                </footer>
                            </div>
                        </div>
                    </nav>

                    {/* Page */}
                    <nav class="box">
                        {/* Title + Options */}
                        <div class="columns">
                            <div class="column">
                                <p class="title is-4"><FontAwesomeIcon className="fas" icon={faTasks} />&nbsp;Session Template</p>
                            </div>
                            <div class="column has-text-right">
                                <Link to={`/session-template/${id}/video-section/add`} class="button is-small is-success is-fullwidth-mobile" type="button">
                                    <FontAwesomeIcon className="mdi" icon={faPlus} />&nbsp;New Video Section
                                </Link>
                            </div>
                        </div>

                        {/* Tab Navigation */}
                        <div class="tabs is-medium">
                            <ul>
                                <li>
                                    <Link to={`/session-template/${id}`}>Detail</Link>
                                </li>
                                {(() => {
                                    // Defensive code: Only run this if we have data.
                                    if (sessionTemplate !== undefined && sessionTemplate !== null && sessionTemplate !== "") {
                                        // Show based on session type.
                                        switch (sessionTemplate.sessionType) {
                                            case "base": return (
                                                <li>
                                                    <Link class="is-active"><strong>Video Sections</strong></Link>
                                                </li>
                                            );
                                            case "sleep": return (
                                                <li>
                                                    <Link to={`/session-template/${id}/sleep-questions`}>Sleep Questions</Link>
                                                </li>
                                            );
                                            case "breath": return (
                                                <li>
                                                    <Link to={`/session-template/${id}/breathwork-options`}>Breathing Options</Link>
                                                </li>
                                            );
                                            default: return null;
                                        };
                                    }
                                    // In case we don't have a session template.
                                    return null;
                                })()}
                            </ul>
                        </div>

                        {isFetching
                            ?
                            <PageLoadingContent displayMessage={"Please wait"} />
                            :
                            <>
                                <div class="columns">

                                    <div class="column">


                                        {sessionTemplate && sessionTemplate.videoSections && sessionTemplate.videoSections.length > 0
                                            ? <>
                                                {sessionTemplate.videoSections.map((object, i) => <VideoSectionRow id={id} obj={object} i={i} key={i} onSelectVideoSectionForDeletion={onSelectVideoSectionForDeletion} />)}
                                            </>
                                            : <>
                                                <div class="hero-body">
                                                  <p class="title">
                                                      <FontAwesomeIcon className="fas" icon={faTable} />&nbsp;No data
                                                  </p>
                                                  <p class="subtitle">
                                                      No data. <b><Link to={`/session-template/${id}/video-section/add`}>Click here&nbsp;<FontAwesomeIcon className="mdi" icon={faArrowRight} /></Link></b> to get started creating your first video section.
                                                  </p>
                                                </div>
                                            </>
                                        }
                                    </div>
                                </div>
                            </>
                        }

                        <div class="columns">
                            <div class="column is-half">
                                <Link to={`/session-templates`} class="button is-fullwidth-mobile"><FontAwesomeIcon className="fas" icon={faArrowLeft} />&nbsp;Back to Session Templates</Link>
                            </div>
                            <div class="column is-half has-text-right">
                                <Link to={`/session-template/${id}/video-section/add`} class="button is-success is-fullwidth-mobile"><FontAwesomeIcon className="fas" icon={faPlus} />&nbsp;New Video Section</Link>
                            </div>
                        </div>

                    </nav>
                </section>
            </div>
        </>
    );
}

function VideoSectionRow(props) {
    const { id, obj, i, onSelectVideoSectionForDeletion } = props;
    if (obj === undefined) {
        return null;
    }
    const { name, detail, exercises } = obj;

    console.log(name, detail, exercises);
    return (
        <div class="box">
            {/*
                ##################################################################
                EVERYTHING INSIDE HERE WILL ONLY BE DISPLAYED ON A DESKTOP SCREEN.
                ##################################################################
            */}
            <div class="is-hidden-touch" >
                <div className="columns">
                    <div className="column is-half">
                        <div class="is-pulled-left">
                            <p class="title is-5">{name}</p>
                            <p class="subtitle is-6">{detail}</p>
                        </div>
                    </div>
                    <div className="column is-half">
                        <div class="is-pulled-right">
                            <Link to={`/session-template/${id}/video-section/${i}`} class="button is-primary"><FontAwesomeIcon className="mdi" icon={faEye} />&nbsp;View</Link>&nbsp;&nbsp;
                        </div>
                    </div>
                </div>
            </div>

            {/*
                ###########################################################################
                EVERYTHING INSIDE HERE WILL ONLY BE DISPLAYED ON A TABLET OR MOBILE SCREEN.
                ###########################################################################
            */}
            <div class="is-hidden-desktop mb-5">
                <strong>Name:</strong>&nbsp;{name}
                <br />
                <br />
                <strong>Detail:</strong>&nbsp;{detail}
                <br />
                <br />

                {/* Tablet only */}
                <div class="is-hidden-mobile pt-2">
                    <div className="buttons">
                        <Link to={`/session-template/${id}/video-section/${i}`} class="button is-primary is-small is-fullwidth-mobile"><FontAwesomeIcon className="mdi" icon={faEye} />&nbsp;View</Link>&nbsp;&nbsp;
                    </div>
                </div>

                {/* Mobile only */}
                <div class="is-hidden-tablet pt-2">
                    <div class="columns is-mobile pt-2">
                        <div class="column">
                            <Link to={`/session-template/${id}/video-section/${i}`} class="button is-primary is-small is-fullwidth-mobile"><FontAwesomeIcon className="mdi" icon={faEye} />&nbsp;View</Link>&nbsp;&nbsp;
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
}


export default SessionTemplateDetailForVideoSection;
